import styled from 'styled-components'

import { BackgroundContainer } from '@reveni-io/reveni-ui'

export const ContentContainer = styled(BackgroundContainer)`
  display: flex;
  align-items: center;
  flex-direction: column;
  box-sizing: border-box;
  min-height: 100vh;
  height: 100%;
  width: 100%;
  padding-bottom: ${props => props.theme.whiteLabel.spacing.sp24};

  > div {
    box-sizing: border-box;

    width: 100%;
    max-width: 390px;

    > div {
      width: 100%;
      box-sizing: border-box;
    }
  }
`

export const FooterContainer = styled.div`
  display: flex;
  height: 30px;
  box-sizing: border-box;
`
